export default __webpack_public_path__ + "static/media/3.0068bf27.png";